/** @format */

import React, { memo, useState } from "react";
import { IMAGES } from "../../constants/constants";
import GetPathsOverlay from "../layouts/GetPathsOverlay";
import { googleStoreLink, appleStoreLink } from "../../constants/constants";
import { auth } from "../../firebase/firebaseConfig";
const Header = (props) => {
  let [showGetPaths, setShowGetPaths] = useState(false);

  const redirectOnAppStore = (storeName) => {
    if (storeName === "apple") {
      window.open(appleStoreLink, "_blank");
    } else {
      window.open(googleStoreLink, "_blank");
    }
  };

  const { userInfo, additionalUserInfo } = props;
  const loggedInUser = userInfo && userInfo.user;
  const userProfile = additionalUserInfo && additionalUserInfo.user;
  const displayName = userProfile
    ? `${userProfile.firstName || ""} ${userProfile.lastName || ""}`.trim()
    : loggedInUser && loggedInUser.displayName
      ? loggedInUser.displayName
      : "";
  const photoURL =
    (userProfile &&
      userProfile.profilePhotoUrls &&
      userProfile.profilePhotoUrls.original) ||
    (loggedInUser && loggedInUser.photoURL) ||
    null;
  const initials = displayName
    ? displayName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "?";

  const handleLogout = props.onLogout || (() => {
    auth.signOut().then(() => window.location.reload());
  });

  return (
    <div className='row header-section'>
      <div className='col header-section-paths-logo'>
        <img alt='new paths logo' src={IMAGES.NEW_PATHS_LOGO.default} />
      </div>
      <div className='header-section-login-buttons-marketplace-icons'>
        {/* Sign In / Sign Up moved to the footer (EntryFooter/FeedFooter) —
            see the invite deep-link + UI cleanup work. */}
        {loggedInUser && (
          <div className='header-user-info'>
            {displayName && (
              <span className='header-user-name'>{displayName}</span>
            )}
            <div className='header-user-avatar'>
              {photoURL ? (
                <img
                  src={photoURL}
                  alt='profile'
                  className='header-avatar-img'
                />
              ) : (
                <div className='header-avatar-placeholder'>{initials}</div>
              )}
            </div>
            <button
              className='header-logout-btn'
              onClick={handleLogout}
              title='Logout'
            >
              <i className='fa fa-sign-out' aria-hidden='true'></i>
            </button>
          </div>
        )}

        {showGetPaths && (
          <GetPathsOverlay
            show={showGetPaths}
            manageGetPaths={() =>
              setShowGetPaths((showGetPaths) => !showGetPaths)
            }
          />
        )}
        <div className='header-section-marketplace-icons'>
          <img
            alt='app store icon'
            src={IMAGES.APP_STORE_ICON.default}
            onClick={() => redirectOnAppStore("apple")}
          />
          <img
            alt='play store icon'
            src={IMAGES.PLAY_STORE_ICON.default}
            onClick={() => redirectOnAppStore("google")}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(Header);
